import { useState } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { StickerRowItem } from "src/components/StickerRow";
import { ParsedStickerRowItem } from "src/components/StickerRow/types";
import Touchable from "src/components/Touchable";
import parseGatheringPreviewTemplateUrl from "src/helpers/parseV0TemplateUrl/parseGatheringPreviewTemplateUrl";
import { radiusSmall } from "src/styles/radius";
import { BlurView, Image } from "src/swsh-native";
import { GatheringPublicPreviewGatheringInfo } from "../../../hooks/useGatheringPublicPreviewInfo";

export type GatheringPreviewPublicPhotoItemPhoto = NonNullable<
	NonNullable<NonNullable<GatheringPublicPreviewGatheringInfo>["previewPhotos"]>["payload"]
>[number];

const GatheringPreviewPublicPhotoItem = ({
	photo,
	blurTier,
	width,
	containerStyle,
	onPress,
	sticker,
}: {
	photo: GatheringPreviewPublicPhotoItemPhoto;
	blurTier: number;
	width: number;
	containerStyle?: StyleProp<ViewStyle>;
	onPress?: (photo: GatheringPreviewPublicPhotoItemPhoto) => void;
	sticker: ParsedStickerRowItem | null;
}) => {
	const url = parseGatheringPreviewTemplateUrl({
		readUrl: photo.readUrl,
	});
	const [didLoad, setDidLoad] = useState(false);
	return (
		<Touchable
			animation="None"
			onPress={() => {
				onPress?.(photo);
			}}
			containerStyle={[
				containerStyle,
				{
					aspectRatio: 3 / 4,
					width,
				},
			]}
		>
			{url && (
				<Image
					alt="Album photo"
					src={url}
					dim={{
						aspectRatio: 3 / 4,
						width,
					}}
					style={{
						borderRadius: radiusSmall,
					}}
					onLoad={() => {
						setDidLoad(true);
					}}
				/>
			)}
			{blurTier > 0 && didLoad && (
				<BlurView
					tint="dark"
					intensity={15 * blurTier}
					style={{
						position: "absolute",
						width: "100%",
						height: "100%",
						borderRadius: radiusSmall,
						overflow: "hidden",
					}}
				/>
			)}
			<StickerRowItem sticker={sticker} />
		</Touchable>
	);
};
export default GatheringPreviewPublicPhotoItem;
